import React, { Component } from 'react';
import './index.css';
import { Timeline } from 'antd';
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { actionGetDeviceDetail } from '../../../../core/actions/scanner/device';
import moment from 'moment'
import { withRouter, RouteComponentProps } from 'react-router-dom';
import './index.css'

interface StateProps {
    deviceDetail: any
}

interface DispatchProps {
    getDetail(data): void
}

interface RouteProp {
    id: string
}

type PropsType = RouteComponentProps<RouteProp> & StateProps
class Index extends Component<PropsType & DispatchProps> {
    

    componentDidMount () {
        let id = this.props.match.params.id;
        let data = {
            serialNumber: id
        }
        this.props.getDetail(data)
    }

    render () {

        let data = this.props.deviceDetail || {};
        let list = data.logs || [];

        return (
            <div className="device model">
                <h3>设备详情</h3>
                <ul className="deviceDetail">
                    <li>
                        <span>设备序列号: </span>
                        {data.serialNumber}
                    </li>
                    <li>
                        <span>当前状态: </span>
                        {data.state === 'OFFLINE' ? '不可用' : '可用'}
                    </li>
                </ul>
                <Timeline className="margin-top-20">
                    {
                        list.map((item, index) => {
                            return (
                                <Timeline.Item key={index}>
                                    {moment(+item.operatingTimestamp).format('YYYY-MM-DD HH:mm:ss')}
                                    {' ' + item.status}
                                </Timeline.Item>
                            )
                        })
                    }
                </Timeline>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        deviceDetail: state.device.deviceDetail
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getDetail: (data) => {
            dispatch(actionGetDeviceDetail(data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Index))